<template>
  <div id="app" class="loading" :class="getCurClass">
    <Header v-if="curBrand != 'kia' && curBrand != 'audi' && curBrand != 'volkswagen' && curBrand != 'bentley' && curBrand != 'zeekr'" />
    <Header_Kia v-if="curBrand == 'kia'" />
    <Header_Audi v-if="curBrand == 'audi'" />
    <Header_VW v-if="curBrand == 'volkswagen'" />
    <Header_Bentley v-if="curBrand == 'bentley'" />
    <Header_Zeekr v-if="curBrand == 'zeekr'" />

    <!-- <Nav /> -->
    <router-view v-if="isRouterAlive" />
    <Footer />
    <!-- <div hidden>The only Audi authorized pre-owned centre in Hong Kong, 100% proven quality. Explore the one-stop service now! Enquiry: 22910000. 奧迪認可易手車中心，全港唯一原廠認證，100%品質保證，立即體驗一站式交易服務，查詢請致電22910000。</div> -->
  </div>
</template>

<script>
import Header from "./components/Header";
import Header_Kia from "./components/Header_Kia";
import Header_Audi from "./components/Header_Audi";
import Header_VW from "./components/Header_VW";
import Header_Bentley from "./components/Header_Bentley";
import Header_Zeekr from "./components/Header_Zeekr";



import Footer from "./components/Footer";
// import Nav from "./components/Nav";
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
      // curBrand: ''
    }
  },
  components: {
    Header,
    Header_Kia,
    Header_Audi,
    Header_VW,
    Header_Bentley,
    Header_Zeekr,
    Footer,
    // Nav,
  },
  created() {
    console.log('window.location````111', window.location.pathname.split('/')[1])
    this.$_curBrand(window.location.pathname.split('/')[1])

  },
  mounted() {
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })

      // setTimeout(()=> {
      //   this.isRouterAlive = true
      // }, 200)
    },
    ...mapMutations([
      '$_curBrand'
    ])
  },
  computed: {
    ...mapState(['curBrand']),
    getCurClass() {
      // 根据根实例的cur返回对应的类名
      return this.curBrand || 'default' // 空字符串时返回'default'
    }
  },
  watch: {
    '$route': () => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    '$route': {
      handler(newVal, oldVal) {
        this.$_curBrand(window.location.pathname.split('/')[1])
        // this.curBrand = window.location.pathname.split('/')[1]
        console.log('导航', window.location.pathname.split('/')[1])

      }
    }

  }
};
</script>

<style>
@import "../static/font.css";
@import "../static/style.css";
</style>

<style lang="scss">


#app.default {
  font-family: 'AttenNewRegular', "Source Han Sans CN";
}

#app h3:hover a {
  color: inherit;
}

#app.kia { 
  font-family: 'Kia', 'AttenNewRegular', "Source Han Sans CN";
}
#app.kia h3 a{
  color: var(--parent-color);
}

#app.kia h3 {
  font-size: 17px;
}
#app.kia{
  .car-wrapper .aui-list .car-b .cta-btns .aui-button .aui-button__text {
    font-size: 14px;
  }
  .car-wrapper .aui-list .car-b .car-specs .spec-key {
    font-size: 14px;
  }
}

#app.audi { 
  font-family: 'Audi', 'sans-serif', 'AttenNewRegular', "Source Han Sans CN";
}
#app.audi h1, #app.audi h3, #app.audi h4 { 
  font-family: 'AudiExtended', 'sans-serif', 'AttenNewRegular', "Source Han Sans CN";
}
#app.audi h3 a{
  color: var(--parent-color);
}
#app.audi h3:hover a{
  color: rgb(0,0,0);
}
#app.audi h3 {
  font-size: 15px;
}
#app.audi{
  .car-wrapper .aui-list .car-b .cta-btns .aui-button .aui-button__text {
    font-size: 13px;
  }
  .car-wrapper .aui-list .car-b .car-specs .spec-key {
    font-size: 13px;
  }
}
#app.volkswagen {
  font-family: 'VWText', '华文细黑','STXihei','PingFang TC', '微软雅黑体', 'AttenNewRegular', "Source Han Sans CN";
  // background-color: #ff0000; /* 红色背景 */
}
#app.volkswagen h1, #app.volkswagen h3, #app.volkswagen h4 { 
  font-family: 'VWHead', '华文细黑','STXihei','PingFang TC', '微软雅黑体', 'AttenNewRegular', "Source Han Sans CN";
}
#app.volkswagen h3:hover a {
  color: rgb(0,64,197);
}

#app.bentley { 
  font-family: 'bentleyLight', Arial, 'sans-serif', 'AttenNewRegular', "Source Han Sans CN";
}
#app.bentley h1, #app.bentley h3, #app.bentley h4 { 
  font-family: 'bentleyRegular', Arial, 'sans-serif', 'AttenNewRegular', "Source Han Sans CN";
}
#app.bentley h1 {
  font-size: 32px;
}
#app.bentley h3 {
  font-size: 18px;
}
#app.bentley{
  .car-wrapper .aui-list .car-b .cta-btns .aui-button .aui-button__text {
    font-size: 13px;
  }
  .car-wrapper .aui-list .car-b .car-specs .spec-key {
    font-size: 13px;
  }
}

#app.bentley h3:hover a{
  color: var(--parent-color);
}

@media (max-width: 768px) {
  
  #app.kia h3 {
    font-size: 20px;
    position: relative;
    a {
      display: -webkit-box;
      -webkit-line-clamp: 2;        /* 最多 2 行 */
      -webkit-box-orient: vertical;
      white-space: initial;
      i {
        position: absolute;
        top:auto;
        bottom: 12px;
      }
    }
    &::after {
      top:auto;
    }
  }
  #app.kia{
    .car-wrapper .aui-list .car-b .cta-btns .aui-button .aui-button__text {
      font-size: 15px;
    }
    .car-wrapper .aui-list .car-b .car-specs .spec-key {
      font-size: 15px;
    }
  }

  #app.volkswagen h3 {
    font-size: 20px;
    position: relative;
    a {
      display: -webkit-box;
      -webkit-line-clamp: 2;        /* 最多 2 行 */
      -webkit-box-orient: vertical;
      white-space: initial;
      i {
        position: absolute;
        top:auto;
        bottom: 12px;
      }
    }
    &::after {
      top:auto;
    }
  }
  #app.volkswagen{
    .car-wrapper .aui-list .car-b .cta-btns .aui-button .aui-button__text {
      font-size: 15px;
    }
    .car-wrapper .aui-list .car-b .car-specs .spec-key {
      font-size: 15px;
    }
  }

  #app.audi h3 {
    font-size: 18px;
    position: relative;
    a {
      display: -webkit-box;
      -webkit-line-clamp: 2;        /* 最多 2 行 */
      -webkit-box-orient: vertical;
      // overflow: hidden;
      white-space: initial;
      i {
        position: absolute;
        top:auto;
        bottom: 12px;
      }
    }
    &::after {
      top:auto;
    }
  }
  #app.audi{
    .car-wrapper .aui-list .car-b .car-title{
      margin: 14px 0 12px;
    }
    .car-wrapper .aui-list .car-b .cta-btns .aui-button .aui-button__text {
      font-size: 15px;
    }
    .car-wrapper .aui-list .car-b .car-specs .spec-key {
      font-size: 14px;
    }
    .car-wrapper .aui-list .car-b .car-specs li {
      font-size: 15px;
    }
  }
  
  #app.bentley h3 {
    font-size: 20px;
    position: relative;
    a {
      display: -webkit-box;
      -webkit-line-clamp: 2;        /* 最多 2 行 */
      -webkit-box-orient: vertical;
      // overflow: hidden;
      white-space: initial;
      i {
        position: absolute;
        top:auto;
        bottom: 12px;
      }
    }
    &::after {
      top:auto;
    }
  }
  #app.bentley{
    .car-wrapper .aui-list .car-b .cta-btns .aui-button .aui-button__text {
      font-size: 14px;
    }
    .car-wrapper .aui-list .car-b .car-specs .spec-key {
      font-size: 14px;
    }
  }


}

#app.zeekr {
  font-family: 'Zeekr-Text-Regular', 'SF Pro Text','Hiragino Sans GB','Microsoft YaHei',sans-serif;;

}
#app.zeekr h1, #app.zeekr h3, #app.zeekr h4 { 
  font-family: 'Zeekr-Text-Regular', 'SF Pro Text','Hiragino Sans GB','Microsoft YaHei',sans-serif;;
}
#app.zeekr h1 {
  font-size: 32px;
}
#app.zeekr h3 {
  font-size: 20px;
}
#app.zeekr h3:hover a{
  color: var(--parent-color);
}
  #app.zeekr {
    .car-wrapper .aui-list .car-b .car-specs .spec-key {
      font-size: 13px;
    }
    .car-wrapper .aui-list .car-b .car-specs li {
      font-size: 14px;
    }
  }

.hei {
  font-family: "微軟正黑體" !important;
}


.el-popover {
    max-width: 288px;
    color: #fff !important;
    border: none !important;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, .05), 0 0 50px 0 rgba(0, 0, 0, .07);
    background: #4c4c4c !important;
    // word-break: keep-all; 
    text-align: left !important;
    padding: 12px;
}
.el-popover.normal {
  word-break: normal; 
}

.el-popover[x-placement^=bottom] .popper__arrow{
    /*el-popover上边三角下层的颜色---也就是视觉上的边框*/
    border-bottom-color: rgba(76, 76, 76, 1) !important;
}
.el-popover[x-placement^=bottom] .popper__arrow::after{
    /*el-popover上边三角表层的颜色---也就是视觉上的角*/
    border-bottom-color: rgba(76, 76, 76, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue